import { Dialog } from '@mui/material';
import type { PrescriptionUploadMedication } from '../../services/api';
import PrescriptionUploadPanel from './PrescriptionUploadPanel';

type Props = {
  open: boolean;
  sessionId: string | null;
  patientId?: number | string | null;
  onClose: () => void;
  onApproved: (rows: PrescriptionUploadMedication[]) => void;
};

export default function PrescriptionUpload({
  open,
  sessionId,
  patientId,
  onClose,
  onApproved,
}: Props) {
  const handleApproved = (rows: PrescriptionUploadMedication[]) => {
    onApproved(rows);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <PrescriptionUploadPanel
        sessionId={sessionId}
        patientId={patientId}
        onApproved={handleApproved}
        onCancel={onClose}
      />
    </Dialog>
  );
}
